import { useEffect, useState, useRef, useContext } from 'preact/hooks'
import Cleave from 'cleave.js/react'
// eslint-disable-next-line no-unused-vars
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.i18n'

import { Loader } from '../../Preloader'
import { Recovery } from '../index'
import { PhoneCodeSelect } from '../PhoneCodeSelect'

import styles from './CountryPhone.module.css'

const CountryPhone = () => {
  const {
    isLoading,
    countryData,
    setSelectedCountry,
    selectedCountry,
    phone,
    setPhone,
  } = useContext(Recovery)

  const [filteredData, setFilteredData] = useState(null)

  const phoneInput = useRef(null)

  useEffect(() => {
    if (!countryData) {
      return
    }
    if (phoneInput.current) {
      phoneInput.current.properties.prefix = selectedCountry.phone_code
      phoneInput.current.setRawValue(selectedCountry.phone_code)
    }
  }, [countryData, selectedCountry, phoneInput])

  const onChangePhone = (e) => {
    setPhone(e.target.rawValue)
  }

  const handleSearch = (e) => {
    if (e.data === null) {
      setFilteredData(null)
    }
    const searchValue = e.target.value.toLowerCase()
    if (searchValue) {
      const filteredData = countryData.filter(
        (item) =>
          item.name.toLowerCase().startsWith(searchValue) ||
          item.phone_code.toLowerCase().includes(searchValue)
      )
      if (filteredData) {
        setFilteredData(filteredData)
      }
    }
  }

  if (countryData === null || isLoading) {
    return <Loader />
  }

  const phonePrefix = selectedCountry.phone_code
  const countryAbbr = selectedCountry.code

  const cleaveOptions = {
    phone: true,
    phoneRegionCode: countryAbbr.toUpperCase(),
    prefix: phonePrefix,
  }

  return (
    <div className={styles.countryPhone}>
      <PhoneCodeSelect
        countryData={countryData}
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        handleSearch={handleSearch}
      />
      <Cleave
        placeholder="+123456789"
        options={cleaveOptions}
        className={styles.countryPhone__input}
        onChange={onChangePhone}
        value={phone}
        ref={phoneInput}
      />
    </div>
  )
}

export default CountryPhone
